import Scripts from './scripts';
import Alpine from 'alpinejs';
import mask from '@alpinejs/mask';
import persist from '@alpinejs/persist';

window.js = Scripts;
window.Alpine = Alpine;

Alpine.plugin(mask);
Alpine.plugin(persist);

Alpine.directive('number-format', (el, { modifiers }) => {
  el.textContent = new Intl.NumberFormat().format(parseInt(el.textContent));
  if (modifiers.indexOf('won') >= 0) {
    el.textContent += '원';
  }
});

Alpine.start();
